import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { FilterService } from '../../filter.service';
import { PromoService } from '../../promo.service';
import { PromoSliderDefaultComponent } from '../../promo-slider-default.component';

@Component({
  selector: 'catalog-promo-slider',
  templateUrl: './promo-slider.component.html',
  styleUrls: ['./promo-slider.component.less']
})
export class CatalogPromoSliderComponent extends PromoSliderDefaultComponent {

  constructor(
    protected promoService: PromoService,
    public filterService: FilterService,
    protected cookie: CookieService,
  ) {
    super(promoService, filterService, cookie);
  }

}
